
import React from 'react'
import request from 'superagent'
import { object } from 'prop-types'

class HarpAlert extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      visible: false,
      message: ''
    }
    this.closeAlert = this.closeAlert.bind(this)
    this.response = this.response.bind(this)
  }

  response (err, res) {
    if (err || !(res && res.body)) return
    const data = res.body
    if (!(data.hasOwnProperty('message') && data.message !== '')) return
    this.setState({
      visible: true,
      message: data.message
    })
  }

  componentDidMount () {
    const { settings } = this.props
    const requestUrl = 'https:' + settings.soapiBase + settings.harpMessageRoute
    try {
      request.get(requestUrl).end(this.response)
    } catch (e) {
      // console.log( e );
    }
  }

  componentDidUpdate () {
    this.props.onShowHide(!(!this.state.visible || this.state.message === ''))
  }

  closeAlert () {
    this.setState({
      visible: false
    })
  }

  render () {
    const { visible, message } = this.state
    if (!visible || message === '') return null
    return (
      <div id='harpAlert' className='alert alert-danger alert-dismissible text-center'>
        <button type='button' className='close' onClick={this.closeAlert} aria-label='Close'><span aria-hidden='true'>x</span></button>
        <p>
          <span dangerouslySetInnerHTML={{ __html: message }} />
        </p>
      </div>
    )
  }
}

HarpAlert.propTypes = {
  settings: object.isRequired
}

export default HarpAlert
